<template>
  <button @click="exportCreditDeposit" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount" :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportCreditDeposit: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 1000;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/client-package', {
          params: params
        });
        params.page += 1;
        response = result.data;
        let activeTime = {};
        let ids = response.docs.map(item => item.client._id);
        let _response = await this.$service.post('/client/first-plan-order', { ids });
        _response.data.forEach(item => {
          activeTime[item._id] = item.confirmTime;
        });
        response.docs.forEach(item => {
          let row = {
            domain: item.client.domain,
            client: `${item.client.companyName})`,
            clientCreateTime: item.client.createTime ? moment(item.client.createTime).format('DD/MM/YYYY HH:mm:ss') : '',
            sales: item.client && item.sales ? item.sales.name : '',
            type: this.$t(item.type),
            amount: item.total,
            numberOfPackage: item.limit,
            numberOfMonth: item.monthCount,
            note: item.note,
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            startTime: item.startTime ? moment(item.startTime).format('DD/MM/YYYY HH:mm:ss') : '',
            expireTime: item.expireTime ? moment(item.expireTime).format('DD/MM/YYYY HH:mm:ss') : '',
            activeTime: activeTime[item.client._id] ? moment(activeTime[item.client._id]).format('MM/DD/YYYY') : '',
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'client-package.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      let cols = [
        {header: 'Domain', key: 'domain', width: 15},
        {header: this.$t('client'), key: 'client', width: 20},
        {header: this.$t('clientCreateTime'), key: 'clientCreateTime', width: 15},
        {header: 'BD', key: 'sales', width: 15},
        {header: this.$t('type'), key: 'type', width: 15},
        {header: this.$t('numberOfPackage'), key: 'numberOfPackage', width: 15},
        {header: this.$t('numberOfMonth'), key: 'numberOfMonth', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 15},
        {header: this.$t('startTime'), key: 'startTime', width: 15},
        {header: this.$t('expireTime'), key: 'expireTime', width: 15},
        {header: this.$t('activeTime'), key: 'activeTime', width: 15},
        {header: this.$t('amount'), key: 'amount', width: 15},
        {header: this.$t('note'), key: 'note', width: 15}
      ];
      sheet.columns = cols;
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        numberOfPackage: 'Number of package',
        numberOfMonth: 'Number of month',
        startTime: 'Start time',
        expireTime: 'Expire time',
        amount: 'Amount',
        packageInfo: 'Package info',
        monthlyUser: 'Monthly user',
        monthlyChannel: 'Monthly channel',
        note: 'Note',
        export: 'Export',
        clientCreateTime: "Client CreateTime",
        activeTime: "Active time",
      },
      vi: {
        numberOfPackage: 'Số gói',
        numberOfMonth: 'Số tháng',
        startTime: 'Ngày bắt đầu',
        expireTime: 'Ngày hết hạn',
        amount: 'Thành tiền',
        packageInfo: 'Thông tin gói',
        monthlyUser: 'TGU',
        monthlyChannel: 'TGC',
        note: 'Ghi chú',
        export: 'Xuất dữ liệu',
        clientCreateTime: "Ngày khách hàng đăng ký",
        activeTime: "Kích hoạt lúc",
      }
    }
  }
}
</script>
